(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hero-product-carousel"] && !Shopify.designMode) return;
  try {
    const initializeHeroProductCarousels = (scope = document) => {
    scope.querySelectorAll('[data-hero-product-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
      const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
      const toggle = carousel.querySelector('[data-carousel-toggle]');
      const status = carousel.querySelector('[data-carousel-status]');
      if (slides.length < 2) return;

      let index = 0;
      let timer;
      const interval = Number(carousel.dataset.interval) || 6000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let userPaused = carousel.dataset.autoplay !== 'true' || reduceMotion;

      const hydrateSlide = (slide) => {
        const template = slide.querySelector('[data-carousel-image-template]');
        if (!template) return;
        template.parentElement.append(template.content.cloneNode(true));
        template.remove();
      };

      const show = (nextIndex, { announce = false, focusSlide = false } = {}) => {
        index = (nextIndex + slides.length) % slides.length;
        hydrateSlide(slides[index]);
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.toggleAttribute('inert', !active);
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (announce && status) status.textContent = slides[index].dataset.announcement;
        if (focusSlide) slides[index].querySelector('a')?.focus();
      };

      const stop = () => {
        window.clearTimeout(timer);
        carousel.classList.remove('is-autoplaying');
      };
      const start = () => {
        stop();
        if (carousel.dataset.autoplay !== 'true' || reduceMotion || userPaused || document.hidden) return;
        void carousel.offsetWidth;
        carousel.classList.add('is-autoplaying');
        timer = window.setTimeout(() => {
          show(index + 1);
          start();
        }, interval);
      };

      const updateToggle = () => {
        if (!toggle) return;
        const label = userPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        toggle.textContent = label;
        toggle.setAttribute('aria-label', label);
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      };

      dots.forEach((dot) => dot.addEventListener('click', () => {
        show(Number(dot.dataset.index), { announce: true });
        start();
      }));
      toggle?.addEventListener('click', () => {
        userPaused = !userPaused;
        updateToggle();
        if (userPaused) stop();
        else start();
      });
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) start();
      });
      document.addEventListener('visibilitychange', start);
      updateToggle();
      start();
    });
  };

  initializeHeroProductCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeHeroProductCarousels(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
      this.carouselView = this.querySelector('[data-gallery-carousel-view]');
      this.carouselStage = this.carouselView?.querySelector('[data-gallery-carousel-stage]');
      this.triggers = Array.from(this.carouselView?.querySelectorAll('[data-gallery-trigger]') || []);
      this.panels = Array.from(this.carouselStage?.querySelectorAll('[data-gallery-panel]') || []);
      this.prevBtn = this.carouselView?.querySelector('.cd-product-gallery__nav--prev');
      this.nextBtn = this.carouselView?.querySelector('.cd-product-gallery__nav--next');
      this.position = this.carouselView?.querySelector('[data-gallery-position]');

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.select(trigger.dataset.galleryTrigger, { syncSelect: true }));
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

      if (this.carouselStage) {
        let touchStartX = null;
        this.carouselStage.addEventListener('touchstart', (event) => {
          touchStartX = event.touches[0]?.clientX ?? null;
        }, { passive: true });
        this.carouselStage.addEventListener('touchend', (event) => {
          if (touchStartX == null) return;
          const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
          const distance = touchEndX - touchStartX;
          touchStartX = null;
          if (Math.abs(distance) >= 48) this.step(distance > 0 ? -1 : 1);
        }, { passive: true });
      }

      // Wire variant picker — listen for cd:variant-change dispatched by product-form
      this._variantMap = this._buildVariantMap();
      this._lightboxVariantPrices = this._buildVariantPriceMap();
      document.addEventListener('cd:variant-change', (e) => {
        this._onVariantChange(e.detail.variantId);
      });

      const autoplayEnabled = String(this.dataset.lightboxAutoplayEnabled || '').trim().toLowerCase();
      this._lightboxAutoplayEnabled = ['true', '1', 'yes', 'on'].includes(autoplayEnabled);
      const rawShowPurchaseControls = String(this.dataset.lightboxShowPurchaseControls || '').trim().toLowerCase();
      this._lightboxShowPurchaseControls = !['false', '0', 'no'].includes(rawShowPurchaseControls);
      const rawDelay = Number(this.dataset.lightboxAutoplayDelay);
      this._lightboxAutoplayDelay = Number.isFinite(rawDelay) ? Math.max(rawDelay, 1) : 5;
      const rawPanelCount = Number(this.dataset.lightboxPanelCount);
      this._lightboxPanelCount = Number.isFinite(rawPanelCount) ? rawPanelCount : 0;
      this._productForm = this.closest('.cd-product-section__inner')?.querySelector('.cd-product-form')
        || this.closest('.cd-product-section')?.querySelector('.cd-product-form');
      this._lightboxFormPlaceholder = null;
      this._lightboxFormInGallery = false;
      this._lightboxDomPlaceholder = null;
      this._lightboxInDocument = false;

      this._initLightbox();
    }

    _initLightbox() {
      this.lightbox = this.querySelector('[data-gallery-lightbox]');
      if (!this.lightbox) return;

      this.lightboxTriggers = Array.from(this.querySelectorAll('[data-gallery-lightbox-trigger]'));
      this.lightboxPanels = Array.from(this.lightbox.querySelectorAll('[data-gallery-panel]'));
      this.lightboxCloseBtn = this.lightbox.querySelector('.cd-product-gallery__lightbox-close');
      this.lightboxPrevBtn = this.lightbox.querySelector('.cd-product-gallery__nav--prev');
      this.lightboxNextBtn = this.lightbox.querySelector('.cd-product-gallery__nav--next');
      this.lightboxStage = this.lightbox.querySelector('.cd-product-gallery__lightbox-stage');
      this.lightboxAutoplayBtn = this.lightbox.querySelector('[data-gallery-lightbox-autoplay]');
      this.lightboxAutoplayState = this.lightbox.querySelector('[data-gallery-lightbox-autoplay-state]');
      this.lightboxTooltip = this.lightbox.querySelector('[data-gallery-lightbox-tooltip]');
      this.lightboxControls = this.lightbox.querySelector('[data-gallery-lightbox-controls]');
      this.lightboxPriceEl = this.lightboxControls?.querySelector('[data-gallery-lightbox-price]');
      this._lightboxDefaultPrice = this.lightboxPriceEl?.textContent?.trim();
      this._lightboxAutoplayPlayLabel = this.lightboxAutoplayBtn?.dataset?.autoplayLabelPlay || 'Play autoplay';
      this._lightboxAutoplayPauseLabel = this.lightboxAutoplayBtn?.dataset?.autoplayLabelPause || 'Pause autoplay';
      this.lightboxThumbs = Array.from(this.lightbox.querySelectorAll('[data-gallery-lightbox-thumb]'));
      this._isLightboxOpen = false;
      this._isLightboxAutoplayPlaying = false;
      this._lightboxDidSwipe = false;

      this.lightboxTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this._openLightbox(trigger.dataset.galleryLightboxTrigger, trigger));
      });

      if (this.lightboxCloseBtn) this.lightboxCloseBtn.addEventListener('click', () => this._closeLightbox());
      if (this.lightboxPrevBtn) this.lightboxPrevBtn.addEventListener('click', () => {
        this._stopLightboxAutoplay();
        this._stepLightbox(-1);
      });
      if (this.lightboxNextBtn) this.lightboxNextBtn.addEventListener('click', () => {
        this._stopLightboxAutoplay();
        this._stepLightbox(1);
      });
      if (this.lightboxAutoplayBtn) {
        this.lightboxAutoplayBtn.addEventListener('click', () => this._toggleLightboxAutoplay());
      }

      this.lightboxThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this._hideLightboxTooltip();
          this._stopLightboxAutoplay();
          this._selectLightbox(thumb.dataset.galleryLightboxThumb, { syncSelect: true });
        });
        thumb.addEventListener('pointerenter', () => this._showLightboxTooltip(thumb));
        thumb.addEventListener('pointerleave', () => this._hideLightboxTooltip());
        thumb.addEventListener('focus', () => this._showLightboxTooltip(thumb));
        thumb.addEventListener('blur', () => this._hideLightboxTooltip());
      });

      this.lightboxPanels.forEach((panel) => {
        panel.addEventListener('click', (event) => {
          if (!event.target.closest('.cd-product-gallery__image')) return;
          if (this._lightboxDidSwipe) return;
          this._toggleLightboxZoom(panel, event);
        });
        panel.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this._toggleLightboxZoom(panel, event);
          }
        });
      });

      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox) this._closeLightbox();
      });

      if (this.lightboxStage) {
        let touchStartX = null;
        this.lightboxStage.addEventListener('touchstart', (event) => {
          touchStartX = event.touches[0]?.clientX ?? null;
        }, { passive: true });
        this.lightboxStage.addEventListener('touchend', (event) => {
          if (touchStartX == null) return;
          const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
          const distance = touchEndX - touchStartX;
          touchStartX = null;
          if (Math.abs(distance) >= 48) {
            this._lightboxDidSwipe = true;
            setTimeout(() => { this._lightboxDidSwipe = false; }, 0);
            this._stopLightboxAutoplay();
            this._stepLightbox(distance > 0 ? -1 : 1);
          }
        }, { passive: true });
      }

      this._updateLightboxAutoplayButton();

      this._onKeydown = (e) => {
        if (this.lightbox.hidden) return;
        if (e.key === 'Escape') this._closeLightbox();
        if (e.key === 'ArrowLeft') {
          this._stopLightboxAutoplay();
          this._stepLightbox(-1);
        }
        if (e.key === 'ArrowRight') {
          this._stopLightboxAutoplay();
          this._stepLightbox(1);
        }
      };
      document.addEventListener('keydown', this._onKeydown);
    }

    _showLightboxTooltip(thumb) {
      const label = thumb.dataset.thumbTooltip;
      if (!this.lightboxTooltip || !label) return;
      this.lightboxTooltip.textContent = label;
      this.lightboxTooltip.hidden = false;

      const thumbRect = thumb.getBoundingClientRect();
      const tooltipRect = this.lightboxTooltip.getBoundingClientRect();
      const margin = 12;
      const left = Math.min(
        Math.max(thumbRect.left + (thumbRect.width - tooltipRect.width) / 2, margin),
        window.innerWidth - tooltipRect.width - margin,
      );
      const top = Math.min(
        thumbRect.bottom + 8,
        window.innerHeight - tooltipRect.height - margin,
      );
      this.lightboxTooltip.style.left = `${left}px`;
      this.lightboxTooltip.style.top = `${top}px`;
    }

    _hideLightboxTooltip() {
      if (this.lightboxTooltip) this.lightboxTooltip.hidden = true;
    }

    _openLightbox(index, trigger) {
      if (!this.lightbox) return;
      this._lightboxReturnFocus = trigger;
      this._mountLightboxToDocument();
      this._selectLightbox(index, { syncSelect: true });
      this.lightbox.hidden = false;
      this.lightbox.classList.remove('is-closing');
      requestAnimationFrame(() => {
        this.lightbox.classList.add('is-open');
      });
      this._isLightboxOpen = true;
      if (this._lightboxShowPurchaseControls) {
        this._mountLightboxProductForm();
        this._updateLightboxPrice();
      }
      this._updateLightboxAutoplayButton();
      // Start autoplay directly, NOT inside requestAnimationFrame: rAF
      // callbacks are suspended while the document is hidden (background tab,
      // some mobile states), so an rAF-deferred start silently never fires
      // and autoplay-on-open appears broken. The timer needs no paint frame,
      // and _startLightboxAutoplay re-checks _shouldStartAutoplay() itself.
      if (this._shouldStartAutoplay()) {
        this._startLightboxAutoplay();
      }
      const primaryControl = this.lightboxControls?.querySelector('[data-cd-product-variant], [data-cd-product-option], [data-cd-qty-input], .cd-product-form__swatch');
      (primaryControl || this.lightboxCloseBtn)?.focus();
    }

    _closeLightbox() {
      if (!this.lightbox) return;
      this._hideLightboxTooltip();
      this._stopLightboxAutoplay();
      this._resetLightboxZoom();
      this.lightbox.classList.remove('is-open');
      this.lightbox.classList.add('is-closing');
      this._isLightboxOpen = false;
      setTimeout(() => {
        if (!this._isLightboxOpen) {
          this.lightbox.hidden = true;
          this.lightbox.classList.remove('is-closing');
          this._restoreLightboxProductForm();
          this._restoreLightboxToGallery();
        }
      }, 190);
      this._lightboxReturnFocus?.focus();
    }

    _mountLightboxProductForm() {
      if (!this._lightboxShowPurchaseControls || this._lightboxFormInGallery || !this._productForm || !this.lightboxControls) return;
      const parent = this._productForm.parentElement;
      if (!parent) return;
      this._lightboxFormPlaceholder = document.createElement('div');
      this._lightboxFormPlaceholder.dataset.galleryProductFormPlaceholder = '';
      this._lightboxFormPlaceholder.style.display = 'none';
      parent.insertBefore(this._lightboxFormPlaceholder, this._productForm);
      this._productForm.classList.add('cd-product-form--lightboxed');
      this.lightboxControls.appendChild(this._productForm);
      this._lightboxFormInGallery = true;
    }

    _restoreLightboxProductForm() {
      if (!this._lightboxFormInGallery || !this._productForm || !this._lightboxFormPlaceholder) return;
      const placeholder = this._lightboxFormPlaceholder;
      const parent = placeholder.parentElement;
      if (parent) {
        parent.insertBefore(this._productForm, placeholder);
        placeholder.remove();
      }
      this._productForm.classList.remove('cd-product-form--lightboxed');
      this._lightboxFormPlaceholder = null;
      this._lightboxFormInGallery = false;
    }

    _mountLightboxToDocument() {
      if (!this.lightbox || this._lightboxInDocument) return;
      const parent = this.lightbox.parentElement;
      if (!parent) return;

      this._lightboxDomPlaceholder = document.createComment('product-gallery-lightbox');
      parent.insertBefore(this._lightboxDomPlaceholder, this.lightbox);
      document.body.appendChild(this.lightbox);
      this._lightboxInDocument = true;
    }

    _restoreLightboxToGallery() {
      if (!this.lightbox || !this._lightboxInDocument || !this._lightboxDomPlaceholder) return;
      const placeholder = this._lightboxDomPlaceholder;
      const parent = placeholder.parentElement;
      if (parent) {
        parent.insertBefore(this.lightbox, placeholder);
        placeholder.remove();
      }
      this._lightboxDomPlaceholder = null;
      this._lightboxInDocument = false;
    }

    _startLightboxAutoplay() {
      this._stopLightboxAutoplay();
      if (!this._shouldStartAutoplay()) return;
      if (!this.lightboxPanels?.length || this.lightboxPanels.length <= 1) return;
      this._resetLightboxZoom();
      this._isLightboxAutoplayPlaying = true;
      this._updateLightboxAutoplayButton();
      this._scheduleLightboxAutoplay();
    }

    _scheduleLightboxAutoplay() {
      if (this._lightboxAutoplayTimer) clearTimeout(this._lightboxAutoplayTimer);
      this._lightboxAutoplayTimer = setTimeout(() => {
        if (!this._isLightboxOpen) return;
        if (!this._isLightboxAutoplayPlaying) return;
        this._stepLightbox(1);
        this._scheduleLightboxAutoplay();
      }, this._lightboxAutoplayDelay * 1000);
    }

    _stopLightboxAutoplay() {
      const wasPlaying = this._isLightboxAutoplayPlaying;
      if (!this._lightboxAutoplayTimer) {
        if (wasPlaying) {
          this._isLightboxAutoplayPlaying = false;
          this._updateLightboxAutoplayButton();
        }
        return;
      }
      clearTimeout(this._lightboxAutoplayTimer);
      this._lightboxAutoplayTimer = null;
      this._isLightboxAutoplayPlaying = false;
      this._updateLightboxAutoplayButton();
    }

    _toggleLightboxAutoplay() {
      if (!this._isLightboxOpen) return;
      if (!this._lightboxAutoplayEnabled || !this.lightboxPanelCanAutoplay()) return;
      if (this._isLightboxAutoplayPlaying) {
        this._stopLightboxAutoplay();
      } else {
        this._startLightboxAutoplay();
      }
    }

    _shouldStartAutoplay() {
      return this._lightboxAutoplayEnabled && this.lightboxAutoplayBtn && this.lightboxPanelCanAutoplay();
    }

    lightboxPanelCanAutoplay() {
      const activePanelCount = this.lightboxPanels?.length || this._lightboxPanelCount || 0;
      return activePanelCount > 1;
    }

  _updateLightboxAutoplayButton() {
      if (!this.lightboxAutoplayBtn) return;
      const canAutoplay = this._lightboxAutoplayEnabled && this.lightboxPanelCanAutoplay();
      const isPlaying = this._isLightboxAutoplayPlaying && canAutoplay;
      this.lightboxAutoplayBtn.dataset.state = isPlaying ? 'playing' : 'paused';
      this.lightboxAutoplayBtn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      this.lightboxAutoplayBtn.classList.toggle('is-playing', isPlaying);
      this.lightboxAutoplayBtn.disabled = !canAutoplay;
      this.lightboxAutoplayBtn.setAttribute('aria-label', isPlaying ? this._lightboxAutoplayPauseLabel : this._lightboxAutoplayPlayLabel);
      if (this.lightboxAutoplayState) this.lightboxAutoplayState.textContent = isPlaying ? this._lightboxAutoplayPauseLabel : this._lightboxAutoplayPlayLabel;
      this.lightbox.classList.toggle('is-autoplaying', isPlaying);
    }

    _buildVariantMap() {
      try {
        const raw = this.dataset.variantMedia;
        if (!raw) return {};
        const entries = JSON.parse('[' + raw + ']');
        const fwd = {};
        const rev = {};
        entries.forEach(({ id, mediaId }) => {
          if (mediaId != null) {
            fwd[String(id)] = mediaId;
            rev[String(mediaId)] = String(id);
          }
        });
        this._reverseMap = rev;
        return fwd;
      } catch (_) { this._reverseMap = {}; return {}; }
    }

    _buildVariantPriceMap() {
      try {
        const raw = this.dataset.lightboxVariantPrices;
        if (!raw) return {};
        const entries = JSON.parse('[' + raw + ']');
        const prices = {};
        entries.forEach(({ id, price }) => {
          if (id == null || typeof price !== 'string') return;
          prices[String(id)] = { price };
        });
        return prices;
      } catch (_) { return {}; }
    }

    _getSelectedVariantId() {
      const select = this._productForm?.querySelector('[data-cd-product-variant]');
      return select?.value || '';
    }

    _updateLightboxPrice(variantId) {
      if (!this.lightboxPriceEl) return;
      const selectedId = String(variantId || this._getSelectedVariantId() || '').trim();
      const mapped = selectedId ? this._lightboxVariantPrices?.[selectedId]?.price : null;
      if (mapped) {
        this.lightboxPriceEl.textContent = mapped;
        return;
      }
      if (this._lightboxDefaultPrice) {
        this.lightboxPriceEl.textContent = this._lightboxDefaultPrice;
      }
    }

    _onVariantChange(variantId) {
      this._updateLightboxPrice(variantId);
      const mediaId = this._variantMap[String(variantId)];
      if (!mediaId) return;
      const panel = this.panels.find(p => p.dataset.mediaId === String(mediaId));
      if (panel) this.select(panel.dataset.galleryPanel, { syncSelect: false });
    }

    _syncSelectToMedia(mediaId) {
      const variantId = (this._reverseMap || {})[String(mediaId)];
      if (!variantId) return;
      const sel = document.querySelector('[data-cd-product-variant]');
      if (!sel || sel.value === variantId) return;
      sel.value = variantId;
      document.dispatchEvent(new CustomEvent('cd:variant-change', {
        bubbles: true,
        detail: { variantId }
      }));
    }

    step(direction) {
      if (!this.panels.length) return;
      const current = this.panels.findIndex(p => !p.hidden);
      const currentIndex = current >= 0 ? current : 0;
      const next = (currentIndex + direction + this.panels.length) % this.panels.length;
      this.select(String(next), { syncSelect: true });
    }

    select(index, { syncSelect = false } = {}) {
      if (!this.panels.length) return;
      let activeMediaId = null;

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.galleryPanel === index;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
        if (isActive) activeMediaId = panel.dataset.mediaId;
      });

      this.triggers.forEach((trigger) => {
        const isActive = trigger.dataset.galleryTrigger === index;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (this.position) this.position.textContent = String(Number(index) + 1);

      // Scroll active thumb into view
      const activeThumb = this.triggers.find(t => t.dataset.galleryTrigger === index);
      if (activeThumb) activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

      // Sync the variant select when user navigates the gallery
      if (syncSelect && activeMediaId) this._syncSelectToMedia(activeMediaId);
    }

    _stepLightbox(direction) {
      if (!this.lightboxPanels?.length) return;
      const current = this.lightboxPanels.findIndex(panel => panel.classList.contains('is-active'));
      const currentIndex = current >= 0 ? current : 0;
      const next = (currentIndex + direction + this.lightboxPanels.length) % this.lightboxPanels.length;
      this._selectLightbox(String(next), { syncSelect: true });
    }

    _toggleLightboxZoom(panel, event) {
      if (!panel?.classList.contains('is-active')) return;
      const willZoom = !panel.classList.contains('is-zoomed');
      this._stopLightboxAutoplay();
      this._resetLightboxZoom();

      if (willZoom) {
        const image = panel.querySelector('.cd-product-gallery__image');
        if (image && Number.isFinite(event?.clientX) && Number.isFinite(event?.clientY)) {
          const rect = image.getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0) {
            const x = Math.min(Math.max(((event.clientX - rect.left) / rect.width) * 100, 0), 100);
            const y = Math.min(Math.max(((event.clientY - rect.top) / rect.height) * 100, 0), 100);
            panel.style.setProperty('--cd-lightbox-zoom-x', `${x}%`);
            panel.style.setProperty('--cd-lightbox-zoom-y', `${y}%`);
          }
        }
        panel.classList.add('is-zoomed');
        panel.setAttribute('aria-pressed', 'true');
        panel.setAttribute('aria-label', panel.dataset.zoomLabelOut);
      }
    }

    _resetLightboxZoom() {
      this.lightboxPanels?.forEach((panel) => {
        panel.classList.remove('is-zoomed');
        panel.style.removeProperty('--cd-lightbox-zoom-x');
        panel.style.removeProperty('--cd-lightbox-zoom-y');
        panel.setAttribute('aria-pressed', 'false');
        panel.setAttribute('aria-label', panel.dataset.zoomLabelIn);
      });
    }

    _selectLightbox(index, { syncSelect = false } = {}) {
      let activeMediaId = null;
      this._resetLightboxZoom();

      this.lightboxPanels.forEach((panel) => {
        const isActive = panel.dataset.galleryPanel === index;
        panel.classList.toggle('is-active', isActive);
        panel.tabIndex = isActive ? 0 : -1;
        if (isActive) activeMediaId = panel.dataset.mediaId;
      });

      this.lightboxThumbs.forEach((thumb) => {
        const isActive = thumb.dataset.galleryLightboxThumb === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      const activeThumb = this.lightboxThumbs.find(thumb => thumb.dataset.galleryLightboxThumb === index);
      if (activeThumb) activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

      if (syncSelect && activeMediaId) this._syncSelectToMedia(activeMediaId);
    }
  }

  if (!customElements.get('product-media-gallery')) {
    customElements.define('product-media-gallery', ProductMediaGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
